__webpack_require__.p = "/wp-content/plugins/ax_tyres_catalog/app/build/";